module.exports = __webpack_public_path__ + "google-pay.2ebf348246c2f47b10833af259a9939f.svg";